module.exports = __webpack_public_path__ + "img/image1.07aa0b32.png";